import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  Select,
  useToast,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import CrmDataService from "../../services/data";
import { DateTime } from "luxon";

export const UpdateEhcExpertModal = ({ isOpen, onClose, id, func }: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const initialRef = React.useRef(null);
  const toast = useToast();

  const [selectedExpert, setSelectedExpert] = useState("");
  const [note, setNote] = useState("");
  const [date, setDate] = useState("");

  const experts = [
    { name: "User1", id: "expert4_tamannarajpal" },
    { name: "User2", id: "expert_mahi" },
    { name: "User3", id: "expert_divanshi" },
    { name: "User4", id: "expert_navyav" },
    { name: "Prakriti", id: "expert_prakriti" },
    { name: "Jigyasa", id: "expert_jigyasa" },
    { name: "Tania", id: "expert_tania" },
  ];

  const now = DateTime.now();

  const updateExpert = (id: any) => {
    const data = {
      assigned_expert: selectedExpert,
      owner_note: note,
      assigned_at: now,
      assigned_for: date,
    };

    if (!id) {
      toast({
        position: "top",
        title: "User not found",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
      return;
    }

    if (!date) {
      toast({
        position: "top",
        title: "Please select a date",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
      return;
    }

    CrmDataService.updateCrmDataById(id, data)
      .then((response: any) => {
        // console.log(response.data, "response.data");
        setSelectedExpert("");
        setDate("");
        setNote("");
        func();
        onClose();
        toast({
          position: "top",
          title: "Expert Updated",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Owner</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Owner</FormLabel>
              <Select
                placeholder="Select Owner"
                value={selectedExpert}
                onChange={(e) => {
                  setSelectedExpert(e.target.value);
                }}
              >
                {experts.map((el) => (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl mt={6}>
              <FormLabel>Assign For</FormLabel>
              <Input
                value={date}
                type="date"
                required
                onChange={(e) => setDate(e.target.value)}
              />
            </FormControl>
            <FormControl mt={6}>
              <FormLabel>Note</FormLabel>
              <Input
                value={note}
                onChange={(e) => {
                  setNote(e.target.value);
                }}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                updateExpert(id);
              }}
            >
              Submit
            </Button>
            <Button
              bgColor={"red"}
              color={"white"}
              onClick={() => {
                setSelectedExpert("");
                setDate("");
                setNote("");
                onClose();
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
